// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createPartnerAccountGroupRequestToJson, deletePartnerAccountGroupRequestToJson, getPartnerAccountGroupMappingRequestToJson, getPartnerAccountGroupMappingResponseFromJson, getPartnerLeadStatsRequestToJson, getPartnerLeadStatsResponseFromJson, getUpdateSubscriptionTierStatusRequestToJson, getUpdateSubscriptionTierStatusResponseFromJson, initiateSubscriptionTierUpdateRequestToJson, partnerCanDoActionRequestToJson, partnerCanDoActionResponseFromJson, resetPartnerRequestToJson, swapPartnerAccountGroupRequestToJson, updatePartnerAccountGroupRequestToJson, updateSubscriptionTierRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function reset(request) {
    await fetchRpc('partner.v1.Partner/Reset', resetPartnerRequestToJson(request));
}
export function reset$(request, options) {
    return defer(() => resetWithTransport$(getGlobalTransport(), request, options));
}
export function resetWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/Reset', resetPartnerRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function updateSubscriptionTier(request) {
    await fetchRpc('partner.v1.Partner/UpdateSubscriptionTier', updateSubscriptionTierRequestToJson(request));
}
export function updateSubscriptionTier$(request, options) {
    return defer(() => updateSubscriptionTierWithTransport$(getGlobalTransport(), request, options));
}
export function updateSubscriptionTierWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/UpdateSubscriptionTier', updateSubscriptionTierRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getUpdateSubscriptionTierStatus(request) {
    const raw = await fetchRpc('partner.v1.Partner/GetUpdateSubscriptionTierStatus', getUpdateSubscriptionTierStatusRequestToJson(request));
    return getUpdateSubscriptionTierStatusResponseFromJson(raw);
}
export function getUpdateSubscriptionTierStatus$(request, options) {
    return defer(() => getUpdateSubscriptionTierStatusWithTransport$(getGlobalTransport(), request, options));
}
export function getUpdateSubscriptionTierStatusWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/GetUpdateSubscriptionTierStatus', getUpdateSubscriptionTierStatusRequestToJson(request), options)
        .pipe(map(resp => getUpdateSubscriptionTierStatusResponseFromJson(resp)));
}
export async function canDoAction(request) {
    const raw = await fetchRpc('partner.v1.Partner/CanDoAction', partnerCanDoActionRequestToJson(request));
    return partnerCanDoActionResponseFromJson(raw);
}
export function canDoAction$(request, options) {
    return defer(() => canDoActionWithTransport$(getGlobalTransport(), request, options));
}
export function canDoActionWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/CanDoAction', partnerCanDoActionRequestToJson(request), options)
        .pipe(map(resp => partnerCanDoActionResponseFromJson(resp)));
}
export async function deletePartnerAccountGroup(request) {
    await fetchRpc('partner.v1.Partner/DeletePartnerAccountGroup', deletePartnerAccountGroupRequestToJson(request));
}
export function deletePartnerAccountGroup$(request, options) {
    return defer(() => deletePartnerAccountGroupWithTransport$(getGlobalTransport(), request, options));
}
export function deletePartnerAccountGroupWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/DeletePartnerAccountGroup', deletePartnerAccountGroupRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getPartnerAccountGroupMapping(request) {
    const raw = await fetchRpc('partner.v1.Partner/GetPartnerAccountGroupMapping', getPartnerAccountGroupMappingRequestToJson(request));
    return getPartnerAccountGroupMappingResponseFromJson(raw);
}
export function getPartnerAccountGroupMapping$(request, options) {
    return defer(() => getPartnerAccountGroupMappingWithTransport$(getGlobalTransport(), request, options));
}
export function getPartnerAccountGroupMappingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/GetPartnerAccountGroupMapping', getPartnerAccountGroupMappingRequestToJson(request), options)
        .pipe(map(resp => getPartnerAccountGroupMappingResponseFromJson(resp)));
}
export async function createPartnerAccountGroup(request) {
    await fetchRpc('partner.v1.Partner/CreatePartnerAccountGroup', createPartnerAccountGroupRequestToJson(request));
}
export function createPartnerAccountGroup$(request, options) {
    return defer(() => createPartnerAccountGroupWithTransport$(getGlobalTransport(), request, options));
}
export function createPartnerAccountGroupWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/CreatePartnerAccountGroup', createPartnerAccountGroupRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function updatePartnerAccountGroup(request) {
    await fetchRpc('partner.v1.Partner/UpdatePartnerAccountGroup', updatePartnerAccountGroupRequestToJson(request));
}
export function updatePartnerAccountGroup$(request, options) {
    return defer(() => updatePartnerAccountGroupWithTransport$(getGlobalTransport(), request, options));
}
export function updatePartnerAccountGroupWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/UpdatePartnerAccountGroup', updatePartnerAccountGroupRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function swapPartnerAccountGroup(request) {
    await fetchRpc('partner.v1.Partner/SwapPartnerAccountGroup', swapPartnerAccountGroupRequestToJson(request));
}
export function swapPartnerAccountGroup$(request, options) {
    return defer(() => swapPartnerAccountGroupWithTransport$(getGlobalTransport(), request, options));
}
export function swapPartnerAccountGroupWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/SwapPartnerAccountGroup', swapPartnerAccountGroupRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function initiateSubscriptionTierUpdate(request) {
    await fetchRpc('partner.v1.Partner/InitiateSubscriptionTierUpdate', initiateSubscriptionTierUpdateRequestToJson(request));
}
export function initiateSubscriptionTierUpdate$(request, options) {
    return defer(() => initiateSubscriptionTierUpdateWithTransport$(getGlobalTransport(), request, options));
}
export function initiateSubscriptionTierUpdateWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/InitiateSubscriptionTierUpdate', initiateSubscriptionTierUpdateRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getPartnerLeadStats(request) {
    const raw = await fetchRpc('partner.v1.Partner/GetPartnerLeadStats', getPartnerLeadStatsRequestToJson(request));
    return getPartnerLeadStatsResponseFromJson(raw);
}
export function getPartnerLeadStats$(request, options) {
    return defer(() => getPartnerLeadStatsWithTransport$(getGlobalTransport(), request, options));
}
export function getPartnerLeadStatsWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Partner/GetPartnerLeadStats', getPartnerLeadStatsRequestToJson(request), options)
        .pipe(map(resp => getPartnerLeadStatsResponseFromJson(resp)));
}
